import React, { useState, useEffect } from 'react'
import { useWeb3React } from '@web3-react/core'
import { Contract, providers, utils } from 'ethers'
import { displayCurrency, displayCurrencyForInput } from '../utils/helpers'
import { useDexContract } from './useContract'
import { useDispatch, useSelector } from 'react-redux'
import { setStateKey ,updateTx } from '../redux/slices/affiliateSlice'
import { useModalStatus } from "./useModalStatus"

interface IModalStatus {
  isShowModalStatus: boolean
  title: string
  msg: string
  contentType: string
  icon: string
}

export const useDex = () => {
  const { account, library } = useWeb3React<providers.Web3Provider>()

  const [balanceDex, setBalanceDex] = useState<any>(0)
  const [modalStatus, setModalStatusState] = useState<IModalStatus>({
    isShowModalStatus: false,
    title: 'Transaction submited',
    msg: '',
    contentType: 'success',
    icon: '',
  })

  const dispatch = useDispatch()
  const affState = useSelector((state) => state.affiliate)
  const bonusState = useSelector((state) => state.bonus)

  const contract = useDexContract()
  const {  setShowModalStaus, 
           modalStatusState ,
           setCloseModalStatus,
           STATUS_TYPE,
           setModalForHandleError
          } = useModalStatus()
  const {  isShowModalStatus } = modalStatusState

  const buyToken = async (value: string) => {
    const overrides = {
      // To convert Ether to Wei:
      value: utils.parseEther(value), // ether in this case MUST be a string
    }

    setShowModalStaus(STATUS_TYPE.WAITING)

    try {
      const result = await contract.buy(overrides)

      const resultConfirm = await result.wait()

      if (resultConfirm.status === 1) {
        setShowModalStaus(STATUS_TYPE.SUCCESS)
      } else {
        throw new Error('Transfer failed')
      }
    } catch (error) {
      setModalForHandleError(error)
    }

    // watchEvent(contract)

    // return { result }
  }

  const buyTokenWithRefAffiliate = async (value: string, address: string , ref:string) => {
    const overrides = {
      value: utils.parseEther(value), // ether in this case MUST be a string
    }

    setShowModalStaus(STATUS_TYPE.WAITING)

    try {
      const result = await contract.buyWithAffiliate(address, overrides)

      const resultConfirm = await result.wait()

      if (resultConfirm.status === 1) {
        setShowModalStaus(STATUS_TYPE.SUCCESS)
        //TODO: update tx to databse
        //  try  {
        //     const updateParam = {
        //     walletAddress : account,
        //     referralWalletAddress :address,
        //     referralKey: ref,
        //    }
        //    dispatch(updateTx(updateParam))
        //  }catch(ex){
        //    console.log(ex)
        //  }
      } else {
        throw new Error('Transfer failed')
      }
    } catch (error) {
      setModalForHandleError(error)
    }
  }

  // const getBalanceDex = async () => {
  //   try {
  //     const res = await contract.balanceOf()
  //     setBalanceDex(displayCurrency(res))
  //   } catch (ex) {
  //     console.log('incorrect chain')
  //   }
  // }

  const getRatioValue = async (token: string, isCoin: boolean) => {
    try {
      const value = utils.parseEther(token)
      const res = await contract.checkReturnValue(value, isCoin)
      if (res) return res
    } catch (ex) {
      console.log('incorrect chain')
    }
  }

  // const watchEvent = (contract: any) => {
  //   contract.on('Bought', () => {
  //     //TODO: somthing went event bought
  //   })
  // }

  /*
    ex.  // setModalStatus(true , "Transaction submited" , "success")
  */
  const setModalStatus = (
    isShowModalStatus: boolean,
    title: string,
    contentType: string,
  ) => {
    setModalStatusState((prevState) => ({
      ...prevState,
      isShowModalStatus: isShowModalStatus,
      title: title,
      contentType: contentType,
    }))
  }

  /*
  const getUserCommission = async () => {    
    try {
      const commision = await contract.userCommission(account)
      dispatch(
        setStateKey({
          key: 'commission',
          value: displayCurrencyForInput(commision),
        }),
      )
    } catch (ex) {
      console.log(ex)
    }
  }*/

  const getUserBonus = async () => {
    try {
      const bonus = await contract.userBonus(account)
      dispatch(
        setStateKey({
          key: 'bonus',
          value: displayCurrencyForInput(bonus),
        }),
      )
    } catch (ex) {
      console.log(ex)
    }
  }

  const widthdrawBonus = async () => {
    try {
      setModalStatus(true, 'Waiting for confirmation', 'loading')
      const result = await contract.withdrawBonus()

      const resultConfirm = await result.wait()
      if (resultConfirm.status === 1) {
        setModalStatus(true, 'Transaction submited', 'success')
        // fetchUserCommission(account)
      } else {
        throw new Error('Transfer failed')
      }
    } catch (ex) {
      setModalStatus(true, 'Widthdraw failed please try again', 'fail')
    }
  }

  return {
    buyToken,
    buyTokenWithRefAffiliate,
    // balanceDex,
    getRatioValue,
    modalStatus,
    setModalStatus,
    // getUserCommission,
    getUserBonus,
    widthdrawBonus,
  }
}
